import { EditOutlined } from '@ant-design/icons';
import { Button, Empty, Skeleton, TablePaginationConfig, Tag } from 'antd';
import { FilterValue, SorterResult } from 'antd/es/table/interface';
import { Column, RecordCountBadge, Table } from 'components';
import {
    StyledTableHeader,
    StyledTableWrapper,
} from 'components/table/table.styled';
import { TableLoader } from 'components/table-loader/table-loader';
import { MatrialFilterFormValuesPaginated } from 'features/master/components/master-filter-form';
import { Dispatch, Fragment, SetStateAction } from 'react';
import { SideBarMenus } from 'routes/constants';
import { VehicleLog } from 'types/vehicle';
import { HasPermission } from 'utils/CheckPermissions';
type LoadingTableProps = {
    isListLoading: boolean;
    vehicleList: VehicleLog[];
    itemsCount: number;
    tableParams: MatrialFilterFormValuesPaginated;
    updateParams: Dispatch<SetStateAction<MatrialFilterFormValuesPaginated>>;
    setmatrialEditData: any;
    setShowAppUserModal: any;
    onApproveReject: any;
    onRefresh :  () => void ;
  isFetching : boolean ;
};
export const MaterialLoadingLogTable = ({
    vehicleList,
    isListLoading,
    itemsCount,
    tableParams,
    updateParams,
    setmatrialEditData,
    setShowAppUserModal,
    onRefresh ,
  isFetching
}: LoadingTableProps) => {
    const handleTableChange = (
        pagination: TablePaginationConfig,
        filters: Record<string, FilterValue | null>,
        sorter: SorterResult<VehicleLog> | SorterResult<VehicleLog>[]
    ) => {
        updateParams({
            ...tableParams,
            page: pagination.current,
            size: pagination.pageSize,
            order_by: Array.isArray(sorter)
                ? undefined
                : sorter.order === 'ascend'
                    ? 'name'
                    : '-name',
        });
    };
    
return (
        <>
            <StyledTableWrapper>
                <StyledTableHeader>
                    <RecordCountBadge text={'Material'} count={itemsCount} />
                     <Button
                        type="link"                // 👈 makes it look like blue text
                        onClick={onRefresh}
                        loading={isListLoading}
                        style={{ padding: 0, marginBottom: 16 }}
                        >
                        Refresh Data
                        </Button>
                </StyledTableHeader>
                <Table<VehicleLog>
                    locale={{
                        emptyText: isListLoading ? <Skeleton active={true} /> : <Empty />
                    }}
                    loading={(isListLoading || isFetching) && { indicator: <TableLoader /> }}
                    dataSource={vehicleList}
                    rowKey="id"
                    onChange={handleTableChange}
                    pagination={{
                        current: tableParams.page,
                        defaultPageSize: tableParams.size,
                        total: itemsCount,
                    }}
                >
                    <Column<VehicleLog> title={'Material Name'} dataIndex={'materialName'} />
                    <Column<VehicleLog> title={'Material Detail'} dataIndex={'materialDetailName'} />
                    <Column<VehicleLog> title={'Material Type'} dataIndex={'materialType'} />

                    <Column<VehicleLog> title={'Bundle Price'} dataIndex={'bundlePrice'} render={(value, record: any) =>
                        record.materialType === "Purchase" ? "-" : value
                    } />
                    <Column<VehicleLog> title={'Purity'} dataIndex={'purity'} render={(value, record: any) =>
                        record.materialType === "Purchase" ? "-" : value
                    } />
                    <Column<VehicleLog> title={'Bundle Size'} dataIndex={'bundleSize'} render={(value, record: any) =>
                        record.materialType === "Purchase" ? "-" : value
                    } />
                    <Column<VehicleLog> title={'Unit Weight'} dataIndex={'unitWeight'} render={(value, record: any) =>
                        record.materialType === "Purchase" ? "-" : value
                    } />
                    <Column<VehicleLog> title={'Unit Price'} dataIndex={'unitPrice'} render={(value, record: any) =>
                        record.materialType === "Purchase" ? "-" : value
                    } />
                    <Column<VehicleLog> title={'Ton Size'} dataIndex={'tonSize'} render={(value, record: any) =>
                        record.materialType === "Purchase" ? "-" : value
                    } />
                    <Column<VehicleLog>
                        title={"Status"}
                        dataIndex={"status"}
                        render={(_, record: any) =>
                            record.status === true ? (
                                <Tag color="green">Active</Tag>
                            ) : (
                                <Tag color="red">Inactive</Tag>
                            )
                        }
                    />

             {HasPermission(SideBarMenus.MATERIALDETAIL, 'edit') ? (
                    <Column
                        title="Action"
                        render={(record) => {
                            return (
                                <Fragment>
                                    {/* Edit Button */}
                                    <div
                                        className="inline-block mr-2 cursor-pointer"
                                        role="button"
                                        onClick={() => {
                                            setShowAppUserModal(true);
                                            setmatrialEditData(record);
                                        }}
                                    >
                                        <EditOutlined />
                                    </div>

                                </Fragment>
                            );
                        }}
                    />
                      ):null}
                      
                </Table>
            </StyledTableWrapper>
        </>
    );
};
